import script from "./GameProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./GameProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./GameProgressBar.vue?vue&type=style&index=0&id=2a51e9e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a51e9e2"]])

export default __exports__